import { Component, Input } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: 'app-data-source-filter-input',
  templateUrl: './data-source-filter-input.component.html',
  styleUrls: ['./data-source-filter-input.component.scss']
})
export class DataSourceFilterInputComponent {
  @Input() dataSource!: MatTableDataSource<any>;
  @Input() placeholder: string = 'Filter';
  @Input() width: string = 'auto';

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
